module.exports = __webpack_public_path__ + "52498afde0927f5463141132558b5160.pdf";